/*
 * Note: This file is used to export all molecules components resolvers
 * so that we can import all of theme from a single file
 * instead of importing each component individually
 * e.g. import
 * Example: import { CardNewsResolver } from "@/components/ui/molecules/resolvers";
 * instead of: import { CardNewsResolver } from "@/components/ui/molecules/cards/card-news/CardNews";
 */

import { ArticleShareResolver } from "./article-share/ArticleShare.resolver"
import { CardNewsResolver } from "./cards/card-news/CardNews.resolver"
import { ChipFilterListResolver } from "./chip-filter-list/ChipFilterList.resolver"

export { CardNewsResolver, ArticleShareResolver, ChipFilterListResolver }
